// Generated from WorkoutLog's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type WorkoutLogCollectionFilterGroups
  = | {
    readonly user: Iri | Iri[]
    readonly workout?: Iri
  }

export const workoutLogCollectionFilterMapping: FilterDefinitionMapping<WorkoutLogCollectionFilterGroups> = {
  user: 'user',
  workout: 'workout',
}

export type WorkoutLogCollectionSort = 'loggedAt'
